var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAsLogo = function SvgAsLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73548 10.5109C2.14449 10.5563 2.09903 11.3957 2.66729 11.5318L15.5327 14.5038C16.5329 12.099 16.5556 9.9664 14.8508 9.46729L2.73548 10.5109Z",
    fill: "url(#paint0_linear_450_2376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1735 8.47025C26.6508 8.42487 26.9236 9.01473 26.5826 9.35503L12.7398 22.831C12.3306 23.2394 11.6715 22.763 11.8988 22.2412L15.5129 14.505C16.513 12.1001 16.5358 9.99027 14.831 9.46847L26.1735 8.47025Z",
    fill: "url(#paint1_linear_450_2376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_450_2376",
    x1: 6.84336,
    y1: 15.1106,
    x2: 13.0338,
    y2: 7.71897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#EA4403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2632,
    stopColor: "#EA4A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#EC5A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EE7203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#F18402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8AE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_450_2376",
    x1: 12.5123,
    y1: 15.1268,
    x2: 26.1095,
    y2: 16.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#EA4403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#EA4A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3928,
    stopColor: "#EC5A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EE7203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#F18402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    stopColor: "#F9B301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFD500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD500"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAsLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/as-logo.931138600fc22a820ca97af1f435cc07.svg";